import axios from "axios";

const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL, // Adjust the base URL as needed
    withCredentials: true,
    // headers: {
    //   'Access-Control-Allow-Origin': process.env.REACT_APP_BASE_URL,
    //   'Content-Type': 'application/json',
    // },
  // timeout: 10_000,
  // can add request/response interceptors here
});

export default axiosClient;
